import { render, staticRenderFns } from "./NewsCategoryEdit.vue?vue&type=template&id=369b1c70&lang=pug"
import script from "./NewsCategoryEdit.vue?vue&type=script&lang=js"
export * from "./NewsCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports